<template>
    <div class="container">
        <div class="row" style="min-height: 100%; min-height: 100vh;">
            <div class="col">

                <form @submit.prevent="atualizar" class="d-flex justify-content-center align-items-center h-100">
                
                    <div class="mt-3" v-if="!nome">
                        <az-loading msg="Aguarde..." />
                    </div>

                    <template v-else>

                        <div class="card az-anime-surgir" style="padding: 0px; max-width: 400px;">

                            <div class="card-header" :class="logo ? 'bg-white' : ''">
                                <div class="d-flex justify-content-center" v-if="false">
                                    <img :src="logo" alt="logo" class="logo-responsive"
                                        v-if="logo && logo != '?'" />
                                    <p class="lead text-center" v-else>{{ nome }}</p>
                                </div>
                                <p class="lead text-center mt-2 mb-0">Bradesco: Reembolso Assistido</p>
                            </div>

                            <div class="card-body">

                                <template v-if="dados.sv">

                                    <div class="form-group">
                                        <az-input
                                            label="Nome"
                                            placeholder="Informar..."
                                            name="nome"
                                            :edicao="!enviando && !verificando"
                                            v-model="dados.nome" />
                                    </div>

                                </template>

                                <div class="form-group">
                                    <az-input
                                        label="Número da Carteira do Bradesco"
                                        placeholder="Informar..."
                                        name="matricula"
                                        :edicao="!enviando && !verificando"
                                        v-model="dados.matricula" />
                                </div>

                                <div class="form-group">
                                    <az-input
                                        label="Identificação de Acesso / Login"
                                        placeholder="Informar..."
                                        name="login"
                                        :edicao="!enviando && !verificando"
                                        v-model="dados.login" />
                                </div>

                                <div class="form-group mb-0">
                                    <az-input
                                        label="Senha de Acesso"
                                        :type="exibir_senha ? 'text' : 'text'"
                                        placeholder="Informar..."
                                        name="dado"
                                        :outras_classes="exibir_senha ? '' : 'entrada'"
                                        :inputname="uuidv4()"
                                        :edicao="!enviando && !verificando"
                                        v-model="dados.senha">
                                        <template v-slot:buttonposb>
                                            <div class="input-group-append">
                                                <button class="btn btn-outline-secondary" type="button" id="button-addon2" @click="exibir_senha = !exibir_senha">
                                                    <i class="fa fa-eye fa-fw" aria-hidden="true" v-if="exibir_senha"></i>
                                                    <i class="fa fa-eye-slash fa-fw" aria-hidden="true" v-else></i>
                                                </button>
                                            </div>
                                        </template>
                                    </az-input>
                                </div>

                            </div>

                            <div class="card-footer d-flex flex-column">

                                <template v-if="verificando">
                                    <div class="alert alert-info mb-0" v-if="!retorno">
                                        <div class="spinner-border" role="status">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        <div class="mt-2">
                                            Verificando Status de Elegibilidade... Aguarde...
                                        </div>
                                    </div>

                                    <div class="alert alert-success mb-0" v-else-if="retorno && retorno.data && retorno.data.fl_elegivel">
                                        <i class="fa fa-check-circle mr-2" aria-hidden="true"></i>
                                        Elegível!
                                    </div>

                                    <!-- Exibição do Retorno -->
                                    <div class="alert mb-0" 
                                        :class="retorno.data.status >= 400 
                                            ? 'alert-danger' 
                                            : ( retorno.data.continuar ? 'alert-info' : 'alert-success' )"
                                        v-else-if="retorno && retorno.data && retorno.data.msg && retorno.data.status">

                                        <div class="spinner-border" role="status" v-if="retorno.data.continuar">
                                            <span class="sr-only">Loading...</span>
                                        </div>
                                        <div v-else-if="retorno.data.status >= 400">
                                            <i class="fa fa-exclamation-triangle fa-2x text-danger" aria-hidden="true"></i>
                                        </div>
                                        <div v-else>
                                            <i class="fa fa-check-circle fa-2x text-success" aria-hidden="true"></i>
                                        </div>

                                        <div class="mt-2">
                                            {{ retorno.data.msg }}
                                        </div>

                                        <div v-if="retorno.data.carencia" class="mt-2">
                                            <hr>
                                            <strong>Carência</strong>
                                            <div v-for="(carencia, titulo, icx) in retorno.data.carencia" :key="icx">
                                                <div class="text-muted small">{{ titulo }}:</div>
                                                <div>{{ carencia }}</div>
                                            </div>
                                        </div>

                                        <div v-if="retorno.data.dados_bancarios" class="mt-2">
                                            <hr>
                                            <strong>Dados Bancários</strong>
                                            <div v-for="(dado, titulo, icx) in retorno.data.dados_bancarios" :key="icx">
                                                <span class="text-muted">{{ titulo }}:</span>
                                                <span class="ml-1">{{ dado }}</span>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="alert alert-warning mb-0" v-else>
                                        Informação não recebida!
                                    </div>

                                    <button type="button" class="btn btn-secondary mt-3" @click="reiniciar()">
                                        Reiniciar
                                    </button>
                                </template>

                                <button
                                    v-else
                                    class="btn btn-primary"
                                    type="submit"
                                    :disabled="enviando || !dados.matricula || !dados.login || !dados.senha || ( dados.sv && !dados.nome )">

                                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="enviando"></span>
                                    <span v-else>Enviar</span>

                                </button>

                            </div>

                        </div>

                    </template>

                </form>

            </div>
        </div>

        <Toast />
    </div>
</template>

<script>
import AzLoading from '../util/AzLoading.vue';
import AzInput from '../shared/forms/AzInput.vue';
import { subscribe, unSubscribe } from "../../service/Notify";

export default {
    data() { 
        return { 
            nome: "", 
            logo: "", 
            dados: { 
                operadora: 'BRADESCO',
                matricula: "", 
                login: "",
                senha: "", 
                canal: "", 
                sv: false, 
            },
            status: null, 
            enviando: false, 
            exibir_senha: false, 
            verificando: false, 
            retorno: null, 
        };
    },

    components: { 
        AzLoading, 
        AzInput, 
    }, 

    methods: { 
        uuidv4() {
            return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },

        atualizar () { 
            this.enviando = true;

            this.axios.post("/reembolso/login/save", this.dados)
                .then(res => {
                    if (res.status < 400) {
                        this.status = res.data;

                        if ( this.dados.sv ) { 

                            this.retorno = { 
                                data: { 
                                    status: 200, 
                                    msg: 'Credenciais enviadas.',
                                }
                            };

                            this.verificando = true;

                        } else { 

                            this.verificando = true;

                            subscribe(window.redir, this.dados.canal, subres => { 
                                this.retorno = subres;

                                if ( !this.retorno.data.continuar ) { 
                                    unSubscribe(window.redir, this.dados.canal);
                                }
                            });

                        }
                        
                    }
                })
                .finally(() => { 
                    this.enviando = false;
                });    
        },

        reiniciar() { 
            window.location.reload();
        },
    },

    beforeDestroy() {
        if ( this.verificando && ( !this.retorno || this.retorno.data.continuar ) ) {
            unSubscribe(window.redir, this.dados.canal);
        }
    },

    beforeMount() { 
        this.dados.sv = this.$route.query.sv ? true : false;
    },

    mounted() {
        this.dados.canal = 'rpa-el-' + this.uuidv4();

        this.axios.get("/subdomain").then(res => {
            this.nome = res.data.name;
            this.logo = res.data.logo;
        });
    }
}
</script>

<style scoped>
.logo-responsive {
  max-width: 100%;
  height: auto;
}

.az-anime-surgir {
  animation: az-surgir 1s;
}

@keyframes az-surgir {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1) ease-in-out;
  }
}

.entrada {
    text-security: circle; /* IE/Safari */
    -moz-text-security: circle; /* FireFox */
    -webkit-text-security: circle; /* Chrome/Safari  */
}
</style>